import React from "react";
import { Container, Row, Col } from "shards-react";
import ViewUser from "../components/user/ViewUsers";
import { toast } from "react-toastify";

class ViewUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  //this is for showing notification
  notify(type, message) {
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type: type,
    });
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row className="py-3">
          <Col lg="12">
            <ViewUser notify={this.notify} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ViewUsers;
